import React, { ReactNode } from 'react';

import Footer from 'components/Footer/Footer';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: ${({ theme }) => theme.colors.neutral.lavenderLight};
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.white};
  @media ${({ theme }) => theme.queries.minLargeDesktop} {
    margin: 20px 100px 0 100px;
    box-shadow: ${({ theme }) => theme.shadows.container.glowDarkBlue};
    border-radius: 16px;
  }
`;

const StickyBottom = styled.div<Props>`
  flex-shrink: 0;
`;

interface Props {
  children: ReactNode;
}

export const SoleraLayout = (props: Props) => {
  const { children } = props;

  return (
    <Container>
      <Content>{children}</Content>
      <StickyBottom>
        <Footer />
      </StickyBottom>
    </Container>
  );
};
